import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.dialogVisible = false;
    this.listObj = {};
    this.defaultFileList = [];
  }
  checkAllSuccess() {
    return Object.keys(this.listObj).every(item => this.listObj[item].hasSuccess);
  }
  handleSubmit() {
    const arr = Object.keys(this.listObj).map(v => this.listObj[v]);
    if (!this.checkAllSuccess()) {
      this.$message('Please wait for all images to be uploaded successfully. If there is a network problem, please refresh the page and upload again!');
      return;
    }
    this.$emit('successCBK', arr);
    this.listObj = {};
    this.defaultFileList = [];
    this.dialogVisible = false;
  }
  handleSuccess(response, file) {
    const uid = file.uid;
    const objKeyArr = Object.keys(this.listObj);
    for (let i = 0, len = objKeyArr.length; i < len; i++) {
      if (this.listObj[objKeyArr[i]].uid === uid) {
        this.listObj[objKeyArr[i]].url = response.files.file;
        this.listObj[objKeyArr[i]].hasSuccess = true;
        return;
      }
    }
  }
  handleRemove(file) {
    const uid = file.uid;
    const objKeyArr = Object.keys(this.listObj);
    for (let i = 0, len = objKeyArr.length; i < len; i++) {
      if (this.listObj[objKeyArr[i]].uid === uid) {
        delete this.listObj[objKeyArr[i]];
        return;
      }
    }
  }
  beforeUpload(file) {
    const fileName = file.uid;
    const img = new Image();
    img.src = window.URL.createObjectURL(file);
    img.onload = () => {
      this.listObj[fileName] = {
        hasSuccess: false,
        uid: file.uid,
        url: '',
        width: img.width,
        height: img.height
      };
    };
  }
};
__decorate([Prop({
  required: true
})], default_1.prototype, "color", void 0);
default_1 = __decorate([Component({
  name: 'EditorImageUpload'
})], default_1);
export default default_1;